import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73c22666"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trending-table"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_thead = _resolveComponent("b-thead");
  const _component_b_td = _resolveComponent("b-td");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createBlock(_component_app_popover, {
    target: $props.target,
    placement: "top",
    "custom-class": "trending-tooltip"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_b_table_simple, null, {
      default: _withCtx(() => [_createVNode(_component_b_thead, null, {
        default: _withCtx(() => [_createVNode(_component_b_tr, null, {
          default: _withCtx(() => [_createVNode(_component_b_th), _createVNode(_component_b_th, null, {
            default: _withCtx(() => [_createTextVNode("Prev. year")]),
            _: 1
          }), _createVNode(_component_b_th, null, {
            default: _withCtx(() => [_createTextVNode("vs.")]),
            _: 1
          }), _createVNode(_component_b_th, null, {
            default: _withCtx(() => [_createTextVNode("Current")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_b_tbody, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.trending_revenue_details, period => {
          return _openBlock(), _createBlock(_component_b_tr, null, {
            default: _withCtx(() => [_createVNode(_component_b_td, null, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(period.label), 1)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, null, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: $props.portfolio[period.last_year],
                precision: "0"
              }, null, 8, ["value"])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, null, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(["trending", $options.processedTrendingValue($props.portfolio[period.vs])])
              }, _toDisplayString($options.trendingValue($props.portfolio[period.vs])), 3)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, null, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: $props.portfolio[period.current_year],
                precision: "0"
              }, null, 8, ["value"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 256))]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  }, 8, ["target"]);
}